export default __webpack_public_path__ + "static/media/checked.6601251e.png";